import React from "react";
import { Col } from "react-bootstrap";

type Props = {
  image: string;
  alt: string;
  url: string;
};

const ProductBrand = ({ image, alt, url }: Props) => {
  return (
    <Col style={{ alignContent: "end" }} className="px-xs-3 px-lg-5">
      <a href={url} target="_blank" rel="noreferrer">
        <img src={image} alt={alt} style={{ maxWidth: "400px" }} />
      </a>
    </Col>
  );
};

export default ProductBrand;
